export class ReferInfo {
    constructor(public referralKey: string,
                public name: string,
                public description: string,
                public utmSource: string,
                public utmMedium: string,
                public utmCampaign: string,
                public utmTerm: string,
                public utmContent,
                public active: boolean) {
    }
}




// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/referrals/refer-info.ts